var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLiveStreamingActive = function SvgLiveStreamingActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0M5.637 4.223a1 1 0 0 1 0 1.414 9 9 0 0 0 0 12.726 1 1 0 1 1-1.414 1.414 11 11 0 0 1 0-15.554 1 1 0 0 1 1.414 0m12.726 0a1 1 0 0 1 1.414 0 11 11 0 0 1 0 15.554 1 1 0 0 1-1.414-1.414 9 9 0 0 0 0-12.726 1 1 0 0 1 0-1.414m-9.895 2.82a1 1 0 0 1-.001 1.415 5 5 0 0 0 0 7.075 1 1 0 1 1-1.414 1.415 7 7 0 0 1 0-9.905 1 1 0 0 1 1.415 0m7.065.01a1 1 0 0 1 1.414 0 7 7 0 0 1 0 9.905 1 1 0 0 1-1.414-1.415 5 5 0 0 0 0-7.075 1 1 0 0 1 0-1.415"
  })));
};
export default SvgLiveStreamingActive;